export default class {
  static init() {
    window.blue_q = window.blue_q || [];
    window.blue_q.push({
      event: 'setCampaignId', value: process.env.GETBLUE_CAMPAIN_ID,
    });
  }

  static invokeEvent(...args) {
    return false;

    // eslint-disable-next-line no-unreachable
    if (typeof window === 'undefined' || !process.env.GETBLUE_CAMPAIN_ID) {
      return false;
    }

    if (!window.blue_q) {
      this.init();
    }

    window.blue_q.push(...args);
    return true;
  }

  static firePageVisit() {
    return this.invokeEvent({
      event: 'setPageType',
      value: 'visit',
    });
  }

  static fireProductVisit(productId) {
    return this.invokeEvent({
      event: 'setProductId', value: productId.toString(),
    }, {
      event: 'setPageType',
      value: 'product',
    });
  }

  static fireCartVisit(productId) {
    return this.invokeEvent({
      event: 'setProductId', value: productId.toString(),
    }, {
      event: 'setPageType',
      value: 'basket',
    });
  }

  static fireConversionVisit(productId, orderId, orderSum) {
    return this.invokeEvent({
      event: 'setProductId', value: productId,
    }, {
      event: 'setTransactionTotal', value: orderSum,
    }, {
      event: 'setTransactionId', value: orderId,
    }, {
      event: 'setPageType',
      value: 'conversion',
    });
  }
}
